import React from 'react'
import './Footer.css'
import { FaFacebook, FaInstagram } from 'react-icons/fa6'
import { Link } from 'react-router-dom'

function Footer() {
  return (
    <div>
        <div className='footer-row'>
            <div className='row-item'>
                <h2>Social Media Pages</h2>
                <div className='socials'>
                    <Link to='https://www.facebook.com/MalaikaDoula' target='_blank' rel='noopener noreferrer' className='socials-item'>
                        <FaFacebook size={50}/>
                    </Link>
                    <Link to='https://www.instagram.com/MalaikaDoula' target='_blank' rel='noopener noreferrer' className='socials-item'>
                        <FaInstagram size={50}/>
                    </Link>
                </div>
            </div>
                

            <div className='row-item'>
                <h2>Services</h2>
                <p>Postpartum Doula Support</p>
                <p>Sibling Doula Support</p>
                <p>Breastfeeding Doula Support</p>
                <p>Sleep Training</p>
            </div>

            <div className='row-item'>
                <h2>Pages</h2>
                <div className='links'>
                    <Link to='/' className='text-decoration-none' style={{color: 'white'}}>
                    Home
                    </Link>
                    <Link to='/services' className='text-decoration-none' style={{color: 'white'}}>
                        Services
                    </Link>
                    <Link to='/reviews' className='text-decoration-none' style={{color: 'white'}}>
                        Reviews
                    </Link>
                    <Link to='/tory' className='text-decoration-none' style={{color: 'white'}}>
                        Our Stories
                    </Link>
                    <Link to='/mission' className='text-decoration-none' style={{color: 'white'}}>
                    </Link>
                    <Link to='/contact-us' className='text-decoration-none' style={{color: 'white'}}>
                        Contact Us
                    </Link>
                </div>
            </div>
        </div>
        <div className='copyright'>
            Copyright © 2026 Malaika Doula Service LLC - All Rights Reserved.
        </div>
    </div>
    
  )
}

export default Footer